import {
  QueryClient,
  queryOptions,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import {
  incidentQueryOptions,
  useExactIncident,
} from 'components/IAP/hooks/incidentHooks';
import config from 'constants/apiConfig';
import axios from 'axios';

export const keys = {
  incidentWorkspaceTeamStatus: 'incidentWorkspaceTeamStatus',
  byIncident: (incidentId?: string) =>
    [keys.incidentWorkspaceTeamStatus, incidentId] as const,
};

export const incidentWorkspaceTeamStatusQueryOptions = (
  incidentId: string,
  queryClient: QueryClient
) =>
  queryOptions({
    queryKey: keys.byIncident(incidentId),
    staleTime: 0,
    queryFn: async () => {
      const incident = await queryClient.ensureQueryData(
        incidentQueryOptions(incidentId)
      );
      if (incident.is_plan) return null;

      const response = await axios<{ teams_status: string | null }[]>(
        config.apiGateway.fetchIncidentStatus,
        { method: 'POST', data: { incidentId } }
      );
      return response.data?.[0]?.teams_status ?? null;
    },
  });

export const useFetchIncidentWorkspaceTeamStatus = (incidentId: string) => {
  const queryClient = useQueryClient();
  const { data: incident } = useExactIncident(incidentId);
  const status = useQuery({
    ...incidentWorkspaceTeamStatusQueryOptions(incidentId, queryClient),
    enabled: Boolean(incident) && !incident?.is_plan,
  });
  return {
    ...status,
    data: !incident || incident.is_plan ? null : status.data,
  };
};
